import SchoolSettings from './SchoolSettings.container';

export default SchoolSettings;
